import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import { useWebReportStore } from '~/stores/webReport'
import { resolveProtectasBrand } from '~/utils/brandTranslation'

/**
 * The single answer to "is this Protectas?" for every branded surface: PDF
 * wordmarks, the Securitas-to-Protectas copy substitution and the browser
 * title. An explicit report brand is authoritative and viewer identity is the
 * fallback — see `resolveProtectasBrand`.
 */
export function useProtectasBrand(): ComputedRef<boolean> {
  const { isProtectasUser } = storeToRefs(useAuthStore())
  const { activeReportProtectasBrand } = storeToRefs(useWebReportStore())

  return computed(() =>
    resolveProtectasBrand(
      activeReportProtectasBrand.value,
      isProtectasUser.value,
    ),
  )
}
